import _ from 'lodash';
import { emitter } from './app';

export const notify = {
  info: (msg, accept) => ts.ui.Notification.info(msg, accept),
  created: (msg) => notify.succeeded(`${msg} is created successfully.`),
  added: (msg) => notify.succeeded(`${msg} is added successfully.`),
  updated: (msg) => notify.succeeded(`${msg} is updated successfully.`),
  removed: (msg) => notify.succeeded(`${msg} is removed successfully.`),
  succeeded: (msg) => ts.ui.Notification.success(msg),
  fail: (msg) => ts.ui.Notification.error(msg),
  failed: (err, msg) => {
    let errorBody;
    const message =
      msg ||
      (err.response ? err.response.message : '') ||
      err.message ||
      'Something went wrong...';

    if (err.response && err.response.data && _.isString(err.response.data)) {
      showErrorDialog({ message, errorBody: err.response.data });
      return;
    }
    if (err && err.response && err.response.data && err.response.data.message) {
      showErrorDialog({ message, errorBody: err.response.data.message });
      return;
    }

    const status = err.response ? err.response.status : 500;
    if ([401, 403].includes(status)) {
      errorBody = 'You are not authorized to do this operation';
    }
    showErrorDialog({ message, errorBody });
  },
};

export const blockingLoader = {
  getLoaderEl: () => document.querySelector('#app > main'),
  show: () =>
    blockingLoader.getLoaderEl().setAttribute('data-ts.blocking', 'Loading'),
  hide: () => blockingLoader.getLoaderEl().removeAttribute('data-ts.blocking'),
};

export const readFileContent = (fileObject) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target?.result);
    reader.onerror = reject;
    reader.readAsText(fileObject);
  });
};

export const showErrorDialog = ({ message, errorBody }) => {
  emitter.emit('show-error', {
    message,
    errorBody,
  });
};

export const isScalar = (variable) => {
  return (
    ['number', 'string', 'boolean', 'undefined'].includes(typeof variable) ||
    variable === null
  );
};

export const copyToClipboard = async (key, value) => {
  try {
    const textToCopy = isScalar(value) ? value : JSON.stringify(value, null, 2);
    await navigator.clipboard.writeText(textToCopy);
    notify.succeeded(`${key} Copied to clipboard`);
  } catch (error) {
    console.error(error);
    notify.failed(error, 'Failed to copy to clipboard');
  }
};

export const isValidUuid = (uuid) => {
  const regex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return regex.test(uuid);
};

export const downloadFile = (fileName, content, type = 'application/json') => {
  const a = document.createElement('a');
  const file = new Blob([content], { type });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
};

export const formatDate = (timestamp) => {
  const date = new Date(timestamp * 1000);

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}Z`;
};
